// extracted by mini-css-extract-plugin
module.exports =  {"location-switcher":"_93444fe79c--location-switcher--wxkHy","footer":"_93444fe79c--footer--U1qQw","preloader-wrapper":"_93444fe79c--preloader-wrapper--ASBJt"};